if (!customElements.get('featured-product-subscription')) {
    customElements.define(
        'featured-product-subscription',
        class FeaturedProductSubscription extends HTMLElement {
            constructor() {
                super();

                const config = {
                    productId: this.dataset.productId,
                    injectionParent: `#subscription-container-${this.dataset.productId}`,
                    selector: `#subscription-container-${this.dataset.productId}`,
                    type: 'page',
                };

                this.waitForObject().then((ReChargeWidget) => {
                    ReChargeWidget.createWidget(config);
                    this.addSubscriptionFunction();
                });

            }

            async addSubscriptionFunction() {
                const addToCartBtn = document.getElementsByClassName(`product-${this.dataset.productId}`);

                const subscriptionBox = `#subscription-container-${this.dataset.productId}`;
                if (subscriptionBox) {
                    const oneTime = await this.waitForElement('.rc_widget__option--onetime', subscriptionBox);
                    const subscription = await this.waitForElement('.rc_widget__option--subsave', subscriptionBox);

                    oneTime.addEventListener('click', () => {
                        window.isSubscription = false;
                    });
                    subscription.addEventListener('click', () => {
                        window.isSubscription = true;
                    });
                }

                const savedScrollPosition = localStorage.getItem('scrollPosition');
                if (savedScrollPosition) {
                    document.documentElement.style.scrollBehavior = 'auto';
                    window.scrollTo(0, parseInt(savedScrollPosition));
                    setTimeout(() => {
                        document.documentElement.style.scrollBehavior = '';
                    }, 50);
                    localStorage.removeItem('scrollPosition');
                }

                addToCartBtn[0].addEventListener('click', () => {
                    if (window.isSubscription) {
                        const productIdPostCartSpecific = document.getElementById(`product_form_${this.dataset.productId}`).querySelector('input[name="id"]').value;
                        event.preventDefault();
                        window.ReChargeWidget.api.postToCart({ id : productIdPostCartSpecific, sellingPlanId: this.dataset.sellingId, sellingPlanGroupId: 0, isSubscription: 1 })
                        localStorage.setItem('scrollPosition', window.scrollY);
                        setTimeout(() => {
                            window.location.href = window.location.href;
                        }, 400);
                    }
                })

            }

            waitForElement(selector, container) {
                return new Promise(resolve => {
                    const containerElement = typeof container === 'string'
                        ? document.querySelector(container)
                        : container;

                    if (!containerElement) {
                        return;
                    }

                    const element = containerElement.querySelector(selector);
                    if (element) {
                        return resolve(element);
                    }

                    const observer = new MutationObserver(mutations => {
                        const element = containerElement.querySelector(selector);
                        if (element) {
                            resolve(element);
                            observer.disconnect();
                        }
                    });

                    observer.observe(containerElement, {
                        childList: true,
                        subtree: true
                    });
                });
            }

            waitForObject() {
                return new Promise((resolve, reject) => {
                    const intervalId = setInterval(() => {
                        if (window.ReChargeWidget) {
                            clearInterval(intervalId);
                            resolve(window.ReChargeWidget);
                        }
                    }, 100);
                });
            }
        }
    );
}